module.exports = __webpack_public_path__ + "img/datas-banner2.ba3ba3a9.png";